import React, { useState } from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { Facebook, Twitter, LinkedIn, Instagram } from '@mui/icons-material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LinkIcon from '@mui/icons-material/Link';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import { getDictionary, getField } from '../../utils/translation/translation';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
const FooterContainer = styled(Box)({
    backgroundColor: 'var(--accent-primary)',
    color: '#FAFAFA',
    padding: '20px',
    fontFamily: "Century Gothic"
});

const FooterLogoSection = styled(Box)({
    marginBottom: '2rem',

});


const SocialMediaSection = styled(Box)({
    display: 'flex',
    gap: '2px',
    flexWrap: 'wrap',
    marginTop: "10px",

});

const SocialMediaIconContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});

const IconBackground = styled(IconButton)({
    backgroundColor: 'white',
    borderRadius: '50%',
    padding: '10px',
    '&:hover': {
        backgroundColor: 'lightgray',
    },
});





const Footer = ({ isMobile, language, translations, footerPadding }: { isMobile: boolean, language: any, translations: any, footerPadding: string }) => {
    const ContactInfoSection = styled(Box)({
        textAlign: 'left',
        fontSize: ' 15px',

    });
    const dictionary = getDictionary(translations, 'footer', language);
    const isArabic = language === 'arabic';
    const website = "www.cloudix.ai";
    const address = 'Dubai';
    const phoneNumber = '+971501286691';
    const email = 'gm@cloudix.ai';
    const facebook = 'https://www.facebook.com/profile.php?id=61562395305957';
    const langCode = language === 'arabic' ? 'ar' : language === 'french' ? 'fr' : 'en';

    const CompanyList = [
        {
            name: getField(dictionary, 'about-us', language),
            link: langCode === 'en' ? `/about-us` : `/${langCode}/about-us`,
        },
        // { name: getField(dictionary, 'contact-us', language), link: '#' },
        {
            name: getField(dictionary, 'blog', language),
            link: langCode === 'en' ? `/blogs` : `/${langCode}/blogs`,
        },
    ];

    const ProductList = [
        {
            name: getField(dictionary, 'online-ordering', language),
            link: langCode === 'en' ? `/online-ordering` : `/${langCode}/online-ordering`,
        },
        {
            name: getField(dictionary, 'crm-marketing', language),
            link: langCode === 'en' ? `/crm-marketing` : `/${langCode}/crm-marketing`,
        },
        {
            name: getField(dictionary, 'branded-apps', language),
            link: langCode === 'en' ? `/branded-apps` : `/${langCode}/branded-apps`,
        },
        {
            name: getField(dictionary, 'qr-digital-menu', language),
            link: langCode === 'en' ? `/qr-digital-menu` : `/${langCode}/qr-digital-menu`,
        },
        {
            name: getField(dictionary, 'loyalty', language),
            link: langCode === 'en' ? `/loyalty` : `/${langCode}/loyalty`,
        },
        {
            name: getField(dictionary, 'qr-dinein-ordering', language),
            link: langCode === 'en' ? `/qr-ordering` : `/${langCode}/qr-ordering`,
        },
    ];

    const commingSoonList = [

        { name: getField(dictionary, 'table-payment', language), link: '#' },
        { name: getField(dictionary, 'reservation', language), link: '#' },
        { name: getField(dictionary, 'driver-app', language), link: '#' },
    ]

    const CopyableField = ({
        icon,
        label,
        value,
        link,
    }: {
        icon: React.ReactNode;
        label: string;
        value: string;
        link?: string;
    }) => {
        const [copied, setCopied] = useState(false);

        const handleCopy = () => {
            navigator.clipboard.writeText(value).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            });
        };

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 2,
                }}
            >
                <Box sx={{ width: 24 }}>{icon}</Box>

                <Typography
                    variant="body2"
                    sx={{ minWidth: isArabic ? 0 : 140, fontWeight: 'bold', mr: 1 }}
                >
                    {label}:
                </Typography>

                <Box sx={{ flex: 1 }}>
                    {link ? (
                        <a
                            href={link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: 'white',
                                textDecoration: 'none',
                            }}
                        >
                            {value}
                        </a>
                    ) : (
                        <Typography>{value}</Typography>
                    )}
                </Box>

                <Box sx={{ position: 'relative', ml: 'auto' }}>
                    {copied && (
                        <Box
                            sx={{
                                position: 'absolute',
                                top: -18,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                fontSize: '0.75rem',
                                color: 'var(--accent-secondary)',
                                px: 1,
                                whiteSpace: 'nowrap',
                                fontWeight: 'bold',
                            }}
                        >
                            Copied
                        </Box>
                    )}
                    <IconButton onClick={handleCopy} aria-label="Copy Button">
                        <ContentCopyIcon sx={{ color: 'var(--accent-secondary)' }} />
                    </IconButton>
                </Box>
            </Box>
        );
    };

    return (
        <>
            <FooterContainer sx={{ marginTop: isMobile ? "3rem" : footerPadding, zIndex: "-1000", direction: isArabic ? "rtl" : "ltr", }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={isMobile ? 12 : 8} >
                        <FooterLogoSection>
                            <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/logo-dark-mode.png`} width={isMobile ? "60%" : "40%"} height="40%" alt='logo' />
                            <div style={{
                                display: isMobile ? "grid" : "flex",
                                flexWrap: "wrap",
                                justifyContent: isMobile ? "" : "space-evenly",
                                alignItems: isMobile ? "center" : "flex-start",
                                marginTop: "4rem"
                            }}>
                                <div>
                                    <Typography variant="h6" component="h6" style={{ color: 'var(--accent-secondary)', textDecoration: 'underline', marginTop: "1rem", fontWeight: "bold" }}>
                                        {getField(dictionary, 'products', language)}
                                    </Typography>
                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        {ProductList.map((product, index) => (
                                            <li key={index} style={{ marginBottom: "10px" }}>
                                                <Link href={product.link} rel="prefetch" color="inherit" underline="hover">
                                                    {product.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div>
                                    {!isMobile && (
                                        <Typography variant="h6" component="h6" style={{ color: 'var(--accent-secondary)', textDecoration: 'underline', marginTop: "1rem", fontWeight: "bold" }}>
                                            {getField(dictionary, 'products', language)}
                                        </Typography>
                                    )}

                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        {commingSoonList.map((product, index) => (
                                            <li key={index} style={{ marginBottom: "10px" }}>
                                                <div>
                                                    <Link
                                                        href={product.link}

                                                        underline="hover"
                                                        style={{
                                                            pointerEvents: "none",
                                                            color: "lightGrey"
                                                        }}
                                                    >
                                                        {product.name}
                                                    </Link>
                                                    <span
                                                        style={{
                                                            fontSize: "0.8rem",
                                                            color: "#aaa",
                                                            marginLeft: "5px",
                                                        }}
                                                    >
                                                        ( {getField(dictionary, 'coming-soon', language)})
                                                    </span>
                                                </div>

                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div>
                                    <Typography variant="h6" component="h6" style={{ color: 'var(--accent-secondary)', textDecoration: 'underline', marginTop: "1rem", fontWeight: "bold" }}>
                                        {getField(dictionary, 'company', language)}
                                    </Typography>
                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        {CompanyList.map((product, index) => (
                                            <li key={index} style={{ marginBottom: "10px" }}>
                                                <Link href={product.link} rel="prefetch" color="inherit" underline="hover">
                                                    {product.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </FooterLogoSection>
                    </Grid>
                    <Grid item xs={12} md={isMobile ? 12 : 4} sx={{ marginTop: isMobile ? " " : "20px", display: isMobile ? "flex" : "grid", justifyContent: "space-between", flexWrap: "wrap" }}>
                        <ContactInfoSection style={{ transform: isMobile ? " " : "translateX(-2rem)" }}>
                            <Typography variant="h6" component="h6" style={{ color: 'var(--accent-secondary)', textDecoration: 'underline', marginTop: "1rem", fontWeight: "bold", textAlign: isArabic ? "right" : "left", }}>
                                {getField(dictionary, 'contacts', language)}
                            </Typography>
                            <div style={{ marginTop: '2rem' }}>
                                <Box sx={{ mt: 2 }}>
                                    <CopyableField
                                        icon={<LocalPhoneIcon />}
                                        label={getField(dictionary, 'phone-number', language)}
                                        value={phoneNumber}
                                        link={`https://wa.me/${phoneNumber}`}
                                    />
                                    <CopyableField
                                        icon={<LocationOnIcon />}
                                        label={getField(dictionary, 'address', language)}
                                        value={address}
                                    />
                                    <CopyableField
                                        icon={<LinkIcon />}
                                        label={getField(dictionary, 'website', language)}
                                        value={website}
                                        link={`https://${website}`}
                                    />
                                    <CopyableField
                                        icon={<AlternateEmailIcon />}
                                        label={getField(dictionary, 'email', language)}
                                        value={email}
                                        link={`mailto:${email}`}
                                    />
                                </Box>
                            </div>
                        </ContactInfoSection>
                        <div>
                            <Typography variant="h6" component="h6" style={{ color: 'var(--accent-secondary)', textDecoration: 'underline', marginTop: "1rem", fontWeight: "bold", transform: isMobile ? " " : "translateX(-2rem)" }}>
                                {getField(dictionary, 'follow-us', language)}
                            </Typography>
                            <SocialMediaSection style={{ transform: isMobile ? "translateX(-2rem)" : "translateX(-4rem)" }}>
                                <SocialMediaIconContainer>
                                    <a href={facebook} target="_blank" rel="noopener noreferrer" style={{ marginLeft: "40px", textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: "column", alignItems: 'center' }}>
                                        <IconBackground color="inherit">
                                            <Facebook sx={{ color: "var(--accent-primary)" }} />
                                        </IconBackground>
                                        <Typography variant="caption" sx={{ color: 'white', marginLeft: '8px' }}>
                                            {getField(dictionary, 'facebook', language)}
                                        </Typography>
                                    </a>
                                </SocialMediaIconContainer>
                                <SocialMediaIconContainer>
                                    <a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noopener noreferrer" style={{ marginLeft: "40px", textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: "column", alignItems: 'center' }}>
                                        <IconBackground color="inherit">
                                            <WhatsAppIcon sx={{ color: "var(--accent-primary)" }} />
                                        </IconBackground>
                                        <Typography variant="caption" sx={{ textDecoration: 'none', color: 'inherit' }}>
                                            {getField(dictionary, 'whatsapp', language)}
                                        </Typography>
                                    </a>

                                </SocialMediaIconContainer>

                                <SocialMediaIconContainer>
                                    <a href={`https://www.instagram.com/cloudix.ai/`} target="_blank" rel="noopener noreferrer" style={{ marginLeft: "40px", textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: "column", alignItems: 'center' }}>
                                        <IconBackground color="inherit">
                                            <Instagram sx={{ color: "var(--accent-primary)" }} />
                                        </IconBackground>
                                        <Typography variant="caption" sx={{ textDecoration: 'none', color: 'inherit' }}>
                                            {getField(dictionary, 'instagram', language)}
                                        </Typography>
                                    </a>
                                </SocialMediaIconContainer>
                            </SocialMediaSection>
                        </div>

                    </Grid>
                </Grid>
                <Box textAlign="center" sx={{ textAlign: "center", padding: "4px", fontFamily: "Century Gothic", marginTop: "2rem", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Link
                        href={langCode === 'en' ? `/terms` : `/${langCode}/terms`}
                        sx={{ color: "#ffffff", textDecoration: "none", mx: 1, fontSize: "13px" }}
                    >
                        {getField(dictionary, 'terms-and-services', language)}
                    </Link>
                    |
                    <Link
                        href={langCode === 'en' ? `/privacy-policy` : `/${langCode}/privacy-policy`}
                        sx={{ color: "#ffffffff", textDecoration: "none", mx: 1, fontSize: "13px" }}
                    >
                        {getField(dictionary, 'privacy-policy', language)}
                    </Link>

                </Box>
            </FooterContainer>



        </>

    );
};

export default Footer;
